import { render } from "./HowCanHelp.vue?vue&type=template&id=5906a314&scoped=true"
import script from "./HowCanHelp.vue?vue&type=script&lang=js"
export * from "./HowCanHelp.vue?vue&type=script&lang=js"

import "./HowCanHelp.vue?vue&type=style&index=0&id=5906a314&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906a314"]])

export default __exports__